import { render, staticRenderFns } from "./LyftStandardDiscountPlanDisclosure.vue?vue&type=template&id=106c617a&"
import script from "./LyftStandardDiscountPlanDisclosure.vue?vue&type=script&lang=js&"
export * from "./LyftStandardDiscountPlanDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports